import React from "react";

import { useAppSelector } from "../../../app/hooks";

import { selectCaseHeader } from "../../caseinfo/logic/Slice";
import ManageEntitiesModal from "./ManageEntitiesModal";

interface ManageEmployeeModalProps {
  onClose: () => void;
  onAdd: () => void;
}

const ManageEmployeeModal: React.FC<ManageEmployeeModalProps> = ({
  onClose,
  onAdd,
}) => {
  const caseData = useAppSelector(selectCaseHeader);

  const employeeList = caseData?.employee_ids || [];

    const items = employeeList.map(employeeId => ({
      id: employeeId,
      title: employeeId,
    }));

  return (
    <ManageEntitiesModal
      title="Employee Details"
      items={items}
      addButtonTitle="Add New Employee"
      onClose={onClose}
      onAdd={onAdd}
    />
  );
};

export default ManageEmployeeModal;